import { render, staticRenderFns } from "./JdsLoader.vue?vue&type=template&id=004ab3a6&scoped=true&"
import script from "./JdsLoader.vue?vue&type=script&lang=ts&"
export * from "./JdsLoader.vue?vue&type=script&lang=ts&"
import style0 from "./JdsLoader.vue?vue&type=style&index=0&id=004ab3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ab3a6",
  null
  
)

export default component.exports